module.exports = __webpack_public_path__ + "img/bitcoin-icon.70d34330.png";